import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { FedExShipmentDto } from 'dtos/fedEx'
import { OhioOutgoingTitleDto, OhioOutgoingTitleVehicleDto } from 'dtos/ohioOutgoingTitles'
import { URIQuery } from 'utils'

const baseUrl = (): string => '/api/ohio-outgoing-titles'
const guidUrl = (guid: string) => `${baseUrl()}/${encodeURIComponent(guid)}`

export const getOhioOutgoingTitleVehicles = (
  ohioOutgoingTitleGuid: string,
  includeOhioOutgoingTitleVehiclesAlreadyInAGroup: boolean,
  cancelToken?: CancelToken
) =>
  apiClient
    .get<ApiResponse<OhioOutgoingTitleVehicleDto[]>>(
      `${guidUrl(ohioOutgoingTitleGuid)}/vehicles` + URIQuery({ includeOhioOutgoingTitleVehiclesAlreadyInAGroup }),
      { cancelToken }
    )
    .then(res => res.data)

export const addVehiclesToOhioOutgoingTitle = (ohioOutgoingTitleGuid: string, vehicles: OhioOutgoingTitleVehicleDto[], cancelToken?: CancelToken) =>
  apiClient.post<ApiResponse<OhioOutgoingTitleDto>>(`${guidUrl(ohioOutgoingTitleGuid)}/vehicles`, vehicles, { cancelToken }).then(res => res.data)

export const removeVehiclesFromOhioOutgoingTitle = (ohioOutgoingTitleGuid: string, vehicles: OhioOutgoingTitleVehicleDto[], cancelToken?: CancelToken) =>
  apiClient.delete<ApiResponse<OhioOutgoingTitleDto>>(`${guidUrl(ohioOutgoingTitleGuid)}/vehicles`, { data: vehicles }).then(res => res.data)

export const getFedExShipment = (ohioOutgoingTitleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExShipmentDto | undefined>>(`${guidUrl(ohioOutgoingTitleGuid)}/fedex-shipment`, { cancelToken }).then(res => res.data)

export const saveFedExShipment = (ohioOutgoingTitleGuid: string, values: FedExShipmentDto, cancelToken?: CancelToken) =>
  apiClient.put<ApiResponse<FedExShipmentDto>>(`${guidUrl(ohioOutgoingTitleGuid)}/fedex-shipment`, values, { cancelToken }).then(res => res.data)
